import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/css/global.css'
import './plugins/element.js'
import cookies from "vue-cookies";
import layer from "layui-layer";
import store from './store'

Vue.config.productionTip = false
Vue.use(cookies)
Vue.use(layer)
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
